/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";
import { PurposedButtonProps } from "./types";

const SettingsButton: FC<PurposedButtonProps> = (props) => (
  <EwaButton2
    data-cy="column-settings-button"
    buttonColor="gray"
    iconName="settings"
    css={labellessButtonCss}
    {...props}
  />
);

export default SettingsButton;
